import { BeAlert, BeRow } from "@beos-css/react/index.ts";

export function AlertDemo() {
	return (
		<section id="demo-alert">
			<h2>Alert (BAlert)</h2>
			<p>
				R5 app_server icons; layout ported from Dano <code>Alert.cpp</code> (pending an R5 pixel pass). Rightmost button is the default.
			</p>
			<BeRow wrap gap="row">
				<BeAlert
					type="stop"
					text="There was a problem mounting the disk. The disk may be damaged or unreadable."
					buttons={["Cancel", "Initialize…"]}
					onButton={() => {}}
				/>
				<BeAlert type="info" text="BeOS is the media OS." buttons={["OK"]} onButton={() => {}} />
			</BeRow>
			<BeRow wrap gap="row">
				<BeAlert type="warning" text="Are you sure you want to empty the Trash?" buttons={["Cancel", "Empty"]} onButton={() => {}} />
				<BeAlert type="idea" text="Tip: drag a Replicant onto the Desktop to keep it handy." buttons={["Got it"]} onButton={() => {}} />
			</BeRow>
		</section>
	);
}
